module.exports = __webpack_public_path__ + "media/images/clearangel_logo_fb_group_card-946fbd7a00cf7dfbd3c04bdf9bf7d4f9.png";